import { PwaWorkspaceSettings } from './types';

export const WorkSpace1PwaSettings: PwaWorkspaceSettings = {
  workspaceId: 'workspace-1',
  appName: 'SpinNova',
  appSlug: 'spin-nova-pwa',
  apiUrl: 'https://api.casinogames-fun.com',
  branding: {
    logo: '/icons/icon-192.png',
    favicon: '/icons/icon-192.png',
    primaryColor: '#7C3AED',
  },
  web: {
    title: 'SpinNova',
    shortName: 'SpinNova',
    description: 'Multi-tenant white-label mobile gaming platform PWA for SpinNova',
    themeColor: '#080B16',
    backgroundColor: '#080B16',
  },
  featureFlags: {
    enableReferrals: true,
    enableSupportChat: true,
    enablePromotions: true,
  },
};

export default WorkSpace1PwaSettings;
